
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { storage } from '@/utils/storage';

const SUPABASE_URL = "https://gmnudsapwqcpujuzkcke.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtbnVkc2Fwd3FjcHVqdXprY2tlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYwMDE2ODMsImV4cCI6MjA2MTU3NzY4M30.aN-qluwY53GTv0N_gY3Nuk_PblzVSFSyDPN3_oKO78k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY, 
  {
    auth: {
      storage: storage,
      persistSession: true,
      autoRefreshToken: true,
    }
  }
);
